import { render, staticRenderFns } from "./ImportSales.vue?vue&type=template&id=839e72fe&scoped=true&"
import script from "./ImportSales.vue?vue&type=script&lang=js&"
export * from "./ImportSales.vue?vue&type=script&lang=js&"
import style0 from "./ImportSales.vue?vue&type=style&index=0&id=839e72fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839e72fe",
  null
  
)

export default component.exports